import { createSvgIcon } from './utils';

export default createSvgIcon(
  <path d="M13.2,0 C15.4312304,-4.09870373e-16 17.24,1.80876961 17.24,4.04 L17.24,13.88 C17.24,16.1112304 15.4312304,17.92 13.2,17.92 L6.04,17.92 C3.80876961,17.92 2,16.1112304 2,13.88 L2,4.04 C2,1.80876961 3.80876961,4.09870373e-16 6.04,0 L13.2,0 Z M14.08,14.96 L5.16,14.96 C4.78996922,14.96 4.49,15.2599692 4.49,15.63 C4.49,16.0000308 4.78996922,16.3 5.16,16.3 L5.16,16.3 L14.08,16.3 C14.4500308,16.3 14.75,16.0000308 14.75,15.63 C14.75,15.2599692 14.4500308,14.96 14.08,14.96 L14.08,14.96 Z" />,
  'Book'
);
